import { createAction, props } from '@ngrx/store';
import { MeasurementTools } from '../../types/measurement-tools';

export const loadODataMeasurementTools = createAction('[Forms] Load OData measurement tools');

export const loadODataMeasurementToolsSuccess = createAction(
    '[Forms] Load OData measurement tools success',
    props<{ measurementTools: MeasurementTools[] }>(),
);

export const loadODataMeasurementToolsFailure = createAction('[Forms] Load OData measurement tools failure');
